<template>
  <v-sheet class="date-range-picker">
    <v-menu v-model="menu" :close-on-content-click="false" :max-width="menuWidth" :min-width="menuWidth"
      :nudge-bottom="4" offset-y origin="top left" transition="scale-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-bind="{ ...attrs, ...$attrs }" :label="label" :value="dateRangeText"
          append-icon="mdi-calendar-range" dense outlined readonly v-on="on" class="pt-2" hide-details></v-text-field>
      </template>

      <div class="date-range-picker__calendars" :class="{
        'date-range-picker__calendars--stacked': stackCalendars,
      }">
        <v-date-picker class="date-range-picker__calendar date-range-picker__calendar--start" :locale="locale"
          :picker-date="leftMonth" :value="selectedRange" :width="calendarWidth" color="#7fc7b2" elevation="0" no-title
          range @change="completeRange" @input="selectDate" @update:picker-date="updateLeftMonth"></v-date-picker>

        <v-divider :vertical="!stackCalendars"></v-divider>

        <v-date-picker class="date-range-picker__calendar date-range-picker__calendar--end" :locale="locale"
          :picker-date="rightMonth" :value="selectedRange" :width="calendarWidth" color="#7fc7b2" elevation="0" no-title
          range @change="completeRange" @input="selectDate" @update:picker-date="updateRightMonth"></v-date-picker>
      </div>
    </v-menu>
  </v-sheet>
</template>

<script>
export default {
  name: "DateRangePicker",
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    locale: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      menu: false,
      selectedRange: [],
      leftMonth: "",
      rightMonth: "",
    };
  },
  computed: {
    dateRangeText() {
      return this.selectedRange.join(" - ");
    },
    viewportWidth() {
      return this.$vuetify.breakpoint.width || 392;
    },
    stackCalendars() {
      return this.viewportWidth < 700;
    },
    calendarWidth() {
      if (!this.stackCalendars) return 320;

      return Math.max(280, Math.min(360, this.viewportWidth - 32));
    },
    menuWidth() {
      return this.stackCalendars
        ? this.calendarWidth
        : this.calendarWidth * 2 + 1;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.selectedRange = this.normalizeRange(value);

        if (!this.menu) {
          this.showSelectedMonths();
        }
      },
    },
    menu(isOpen) {
      if (isOpen) {
        this.showSelectedMonths();
      } else if (this.selectedRange.length !== 2) {
        this.selectedRange = this.normalizeRange(this.value);
      }
    },
  },
  methods: {
    copyRange(value) {
      return Array.isArray(value) ? value.filter(Boolean).slice(0, 2) : [];
    },
    normalizeRange(value) {
      const range = this.copyRange(value);

      return range.length === 2 ? range.sort() : range;
    },
    currentMonth() {
      const date = new Date();
      const month = String(date.getMonth() + 1).padStart(2, "0");

      return `${date.getFullYear()}-${month}`;
    },
    addMonths(month, amount) {
      const [year, monthNumber] = month.split("-").map(Number);
      const date = new Date(year, monthNumber - 1 + amount, 1);
      const nextMonth = String(date.getMonth() + 1).padStart(2, "0");

      return `${date.getFullYear()}-${nextMonth}`;
    },
    showSelectedMonths() {
      const [startDate, endDate] = this.selectedRange;
      const startMonth = startDate
        ? startDate.substring(0, 7)
        : this.currentMonth();
      const endMonth = endDate ? endDate.substring(0, 7) : null;

      this.leftMonth = startMonth;
      this.rightMonth =
        endMonth && endMonth !== startMonth
          ? endMonth
          : this.addMonths(startMonth, 1);
    },
    updateLeftMonth(month) {
      this.leftMonth = month;
    },
    updateRightMonth(month) {
      this.rightMonth = month;
    },
    selectDate(value) {
      this.selectedRange = this.copyRange(value);
    },
    completeRange(value) {
      const range = this.normalizeRange(value);

      this.selectedRange = range;
      this.$emit("input", range);
      this.$emit("change", range);
      this.menu = false;
    },
  },
};
</script>

<style scoped>
.date-range-picker {
  min-width: 0;
  width: 100%;

}



.date-range-picker__calendars {
  align-items: stretch;
  background: #fff;
  display: flex;
  overflow: hidden;
}

.date-range-picker__calendars--stacked {
  flex-direction: column;
}

.date-range-picker__calendar {
  border-radius: 0;
  flex: 0 0 auto;
}
</style>
